import styled, { ThemeProvider } from "styled-components";
import { useAppSelector } from "../../app/hooks";
import { scheduleState } from "../../app/reducers/schedule-slice";
import theme from "../../style/theme";
import { DeliveryGroupDialogContent } from "./DeliveryGroupDialogContent";

export const DeliveryGroupDialog = () => {
  const { dialogSchedule, dialogDeliveryGroupIndex } =
    useAppSelector(scheduleState);

  if (!dialogSchedule || dialogDeliveryGroupIndex === undefined) {
    return null;
  }

  const deliveryGroup = dialogSchedule.deliveryGroups[dialogDeliveryGroupIndex];

  return (
    <Container>
      <ThemeProvider theme={theme}>
        <DeliveryGroupDialogContent
          schedule={dialogSchedule}
          deliveryGroup={deliveryGroup}
        />
      </ThemeProvider>
    </Container>
  );
};

const Container = styled.div``;
